

document.addEventListener('DOMContentLoaded', function() {
  // Get settings from section data attributes
  const section = document.querySelector('.siccas-microconv-settings');
  if (!section) return;
  
  const showPhoneText = section.dataset.showPhoneText || 'Show phone';
  const showEmailText = section.dataset.showEmailText || 'Show email';
  const contactVisibilityDays = parseInt(section.dataset.contactVisibilityDays) || 7;
  
  const STORAGE_KEY = 'siccas_microconv_contacts';
  
  // Function to get stored contact data
  function getStoredContacts() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }
  
  // Function to save contact click
  function saveContactClick(contactHref) {
    const contacts = getStoredContacts();
    contacts[contactHref] = new Date().getTime();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(contacts));
  }
  
  // Function to check if contact should be visible
  function shouldShowContact(contactHref) {
    const contacts = getStoredContacts();
    const clickTime = contacts[contactHref];
    
    if (!clickTime) return false;
    
    const now = new Date().getTime();
    const daysPassed = (now - clickTime) / (1000 * 60 * 60 * 24);
    
    if (daysPassed > contactVisibilityDays) {
      // Clean up old entry
      delete contacts[contactHref];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(contacts));
      return false;
    }
    
    return true;
  }
  
  // Function to get page class from URL
  function getPageClass() {
    const pathname = window.location.pathname;
    let pageClass = 'page-home';
    
    if (pathname && pathname !== '/') {
      // Remove leading/trailing slashes and replace remaining with hyphens
      const cleanPath = pathname.replace(/^\/|\/$/g, '').replace(/\//g, '-');
      if (cleanPath) {
        pageClass = 'page-' + cleanPath;
      }
    }
    
    return pageClass;
  }
  
  // Function to get first place-* class from element
  function getPlaceClass(element) {
    const classes = Array.from(element.classList);
    const placeClass = classes.find(cls => cls.startsWith('place-'));
    return placeClass || '';
  }
  
  // Main function to process contacts
  function processContacts() {
    const containers = document.querySelectorAll('.microconv-hide-contacts');
    const pageClass = getPageClass();
    
    containers.forEach(container => {
      const placeClass = getPlaceClass(container);
      
      // Find all tel and mailto links within this container
      const contactLinks = container.querySelectorAll('a[href^="tel:"], a[href^="mailto:"]');
      
      contactLinks.forEach(link => {
        // Skip if already processed
        if (link.parentElement.classList.contains('microconv-contact-wrapper')) {
          return;
        }
        
        // Determine contact type
        const isPhone = link.href.startsWith('tel:');
        const contactType = isPhone ? 'contacts-phone' : 'contacts-email';
        const buttonText = isPhone ? showPhoneText : showEmailText;
        
        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'microconv-contact-wrapper';
        
        // Create button
        const button = document.createElement('button');
        button.className = 'microconv-button';
        button.classList.add(contactType);
        if (placeClass) button.classList.add(placeClass);
        button.classList.add(pageClass);
        button.textContent = buttonText;
        
        // Check if contact should already be visible
        if (shouldShowContact(link.href)) {
          button.classList.add('microconv-hidden');
        }
        
        // Add click handler
        button.addEventListener('click', function() {
          this.classList.add('microconv-hidden');
          
          // Save contact click to localStorage
          saveContactClick(link.href);
        });
        
        // Wrap the link
        link.parentNode.insertBefore(wrapper, link);
        wrapper.appendChild(link);
        wrapper.appendChild(button);
      });
    });
  }
  
  // Initialize
  processContacts();
  
  // Also run on dynamic content changes if needed
  // Can be called from other scripts: window.siccasMicroconvUpdate = processContacts;
  window.siccasMicroconvUpdate = processContacts;
});